import { render, staticRenderFns } from "./CsResumenServicio.vue?vue&type=template&id=72fdd3b8"
import script from "./CsResumenServicio.vue?vue&type=script&lang=js"
export * from "./CsResumenServicio.vue?vue&type=script&lang=js"
import style0 from "./CsResumenServicio.vue?vue&type=style&index=0&id=72fdd3b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports